import React, { useEffect, useState } from "react"
import { Editor } from "react-draft-wysiwyg"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import { ContentState, convertToRaw, EditorState } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import { filesActions } from "../../helpers/filesHelpers"
import { useTranslation } from "react-i18next"
import './style.css'

const { readFileAsDataURL } = filesActions

const CustomEditor = (props) => {
	const { onTextChange, initialHtmlContent } = props
	const {i18n} = useTranslation()
	const [editorState, setEditorState] = useState(initialHtmlContent ? createEditorStateWithContent() : EditorState.createEmpty())

	useEffect(() => {
		if (initialHtmlContent)
			setEditorState(createEditorStateWithContent())
	}, [initialHtmlContent])

	function uploadCallback(file){
		return new Promise((resolve, reject) => {
			readFileAsDataURL(file).then(value => {
				resolve({ data: { link: value }})
			})
		})
	}

	function onEditorStateChanged(state){
		const htmlText = replaceImage(draftToHtml(convertToRaw(state.getCurrentContent())))
		const text = state.getCurrentContent().getPlainText('\u0001')
		onTextChange(htmlText, text)
		setEditorState(state)
	}
	function createEditorStateWithContent(){
		return EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(initialHtmlContent).contentBlocks))
	}
	function replaceImage(htmlText){
		return htmlText.replace('<div style="text-align:unset;"><img alt=""', '<div style="text-align:center;"><img alt=""')
	}
	return (
		<Editor
			editorState={ editorState }
			localization={{locale: i18n.language}}
			toolbar={{
				image: {
					uploadCallback : uploadCallback,
                    previewImage   : true
				}
			}}
			toolbarClassName="editor-toolbar"
			wrapperClassName="custom-editor"
			onEditorStateChange={ onEditorStateChanged }
			{ ...props }
		/>
	)
}

export default CustomEditor